/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    INIT_AND_RESET_BIAXIAL_VERTICAL_STRIP_PROGRAM_SCREEN,
    INIT_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN,
    RESET_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN,
    SET_CURRENT_HIGHLIGHT_INDEX_PROGRAM_SCREEN,
    SET_CURRENT_TOTAL_ITEMS_PROGRAM_SCREEN,
    SET_CURRENT_VERTICAL_HIGHLIGHT_INDEX_PROGRAM_SCREEN,
    SET_GRADIENT_FOR_PROGRAM_SCREEN,
    SET_HORIZONTAL_OPTIONS_PROGRAM_SCREEN,
    SET_LEFT_GRADIENT_VISIBILITY,
    SET_PROGRAM_SCREEN_CARET,
    SET_RIGHT_GRADIENT_VISIBILITY,
} from './programscreen.types';

export const initBiaxialHorizontalStripProgramScreenAction = (
    currentHighlightIndex: number,
    totalItems: number,
): TivoPayloadAction<{ currentHighlightIndex: number; totalItems: number }> => {
    return {
        type: INIT_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN,
        payload: { currentHighlightIndex, totalItems },
    };
};

export const initAndResetBiaxialVerticalStripProgramScreenAction = (
    currentVerticalHighlightIndex: number,
    totalVerticalItems: number,
): TivoPayloadAction<{ currentVerticalHighlightIndex: number; totalVerticalItems: number }> => {
    return {
        type: INIT_AND_RESET_BIAXIAL_VERTICAL_STRIP_PROGRAM_SCREEN,
        payload: { currentVerticalHighlightIndex, totalVerticalItems },
    };
};

export const resetBiaxialHorizontalStripProgramScreenAction = (): TivoPayloadAction<{
    currentHighlightIndex: number;
    totalItems: number;
}> => {
    return {
        type: RESET_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN,
        payload: {
            currentHighlightIndex: 0,
            totalItems: 0,
        },
    };
};

export const setCurrentHighlightIndexProgramScreenAction = (
    currentHighlightIndex: number,
): TivoPayloadAction<{ currentHighlightIndex: number }> => {
    return {
        type: SET_CURRENT_HIGHLIGHT_INDEX_PROGRAM_SCREEN,
        payload: {
            currentHighlightIndex,
        },
    };
};

export const setCurrentVerticalHighlightIndexProgramScreenAction = (
    currentVerticalHighlightIndex: number,
): TivoPayloadAction<{ currentVerticalHighlightIndex: number }> => {
    return {
        type: SET_CURRENT_VERTICAL_HIGHLIGHT_INDEX_PROGRAM_SCREEN,
        payload: {
            currentVerticalHighlightIndex,
        },
    };
};

export const setProgramScreenCaretVisibleAction = (
    isCaretVisible: boolean,
): TivoPayloadAction<{
    isCaretVisible: boolean;
}> => ({
    type: SET_PROGRAM_SCREEN_CARET,
    payload: { isCaretVisible },
});

export const setHoverGradientVisibleAction = (
    isGradientVisible: boolean,
): TivoPayloadAction<{
    isGradientVisible: boolean;
}> => ({
    type: SET_GRADIENT_FOR_PROGRAM_SCREEN,
    payload: { isGradientVisible },
});

export const setTotalItemsProgramScreenActions = (
    totalItems: number,
): TivoPayloadAction<{ totalItems: number }> => {
    return {
        type: SET_CURRENT_TOTAL_ITEMS_PROGRAM_SCREEN,
        payload: {
            totalItems,
        },
    };
};

export const setHorizontalOptionsProgramScreenAction = (
    horizontalOptions: any,
): TivoPayloadAction<{ horizontalOptions: any }> => {
    return {
        type: SET_HORIZONTAL_OPTIONS_PROGRAM_SCREEN,
        payload: {
            horizontalOptions,
        },
    };
};

export const setRightGradientVisibleAction = (
    showRightGradient: boolean,
): TivoPayloadAction<{
    showRightGradient: boolean;
}> => ({
    type: SET_RIGHT_GRADIENT_VISIBILITY,
    payload: { showRightGradient },
});

export const setLeftGradientVisibleAction = (
    showLeftGradient: boolean,
): TivoPayloadAction<{
    showLeftGradient: boolean;
}> => ({
    type: SET_LEFT_GRADIENT_VISIBILITY,
    payload: { showLeftGradient },
});

